var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntegrationPreferSignup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.417 61C106.417 64.25 104.717 67.1 101.917 68.65L96.4675 71.75L74.7675 83.95C71.2675 85.9 67.3175 86.9 63.4175 86.9C59.4675 86.9 55.5175 85.9 52.0175 83.95L30.3175 71.75L24.8675 68.7C22.0675 67.1 20.4175 64.25 20.4175 61C20.4175 57.8 22.0675 54.9 24.8675 53.35L30.6675 50.1L52.0175 62.15C55.5175 64.1 59.4675 65.1 63.4175 65.1C67.3175 65.1 71.2675 64.1 74.7675 62.15L96.1175 50.1L101.917 53.35C104.717 54.9 106.417 57.8 106.417 61Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.417 39.2026C106.417 42.4026 104.717 45.3026 101.917 46.8526L96.1175 50.1025L74.7675 62.1525C71.2675 64.1025 67.3175 65.1025 63.4175 65.1025C59.4675 65.1025 55.5175 64.1025 52.0175 62.1525L30.6675 50.1025L24.8675 46.8526C22.0675 45.3026 20.4175 42.4026 20.4175 39.2026C20.4175 36.0026 22.0675 33.1026 24.8675 31.5526L52.0175 16.2526C59.0675 12.3526 67.7675 12.3526 74.7675 16.2526L101.917 31.5526C104.717 33.1026 106.417 36.0026 106.417 39.2026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.417 82.452C106.417 85.702 104.717 88.552 101.917 90.152L74.7675 105.402C71.2675 107.352 67.3175 108.352 63.4175 108.352C59.4675 108.352 55.5175 107.352 52.0175 105.402L24.8675 90.152C22.0675 88.552 20.4175 85.702 20.4175 82.452C20.4175 79.252 22.0675 76.402 24.8675 74.802L30.3175 71.752L52.0175 83.952C55.5175 85.902 59.4675 86.902 63.4175 86.902C67.3175 86.902 71.2675 85.902 74.7675 83.952L96.4675 71.752L101.917 74.802C104.717 76.402 106.417 79.252 106.417 82.452Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationPreferSignup);
export default __webpack_public_path__ + "static/media/integration_prefer_signup.3172e89f313a7c60b3f217940acf67d5.svg";
export { ForwardRef as ReactComponent };